import { IColors } from "@swiggy-private/dls-web-common/dist/components/types.internal";
import styled from "styled-components";

export const ComparisonHalfCardCta = styled.div<{ underlineColor: keyof IColors }>(({ theme, underlineColor }) => ({
    marginTop: theme.spacing.xxSmall,
    display: "inline-block",
    maxWidth: "62%",
    textDecoration: "underline",
    textDecorationColor: theme.colors[theme.colorMode][underlineColor],
}));
